import { IOptions } from "components/DropdownSelect";

export enum FornecedorAutorizacaoPlaca {
  CONTINENTAL = "continental",
  CBM = "CBM",
}

export const opcoesFornecedorAutorizacaoPlaca: IOptions[] = [
  { value: FornecedorAutorizacaoPlaca.CONTINENTAL, label: "Continental" },
  { value: FornecedorAutorizacaoPlaca.CBM, label: "CBM" },
];